import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const LocationContext = /*#__PURE__*/createContext(window.location);
/** @deprecated */
export function LocationProvider(props) {
  const {
    children,
    location
  } = props;
  return /*#__PURE__*/_jsx(LocationContext.Provider, {
    value: location,
    children: children
  });
}

/** @deprecated use the hook from react-router instead. */
export const useLocation = () => {
  return useContext(LocationContext);
};

/** @deprecated */
export const useLocationCommonActions = () => {
  const locationContext = useContext(LocationContext);
  return {
    getPageUrl: () => {
      return locationContext.origin + locationContext.pathname;
    }
  };
};